import React from 'react';

import { Typography } from '@material-ui/core';

import { Section } from '../../../components';
import { useStyles } from '../styles';

export default function PreviewPolicy({ scheme, isValidForLive }) {
  const classes = useStyles();

  return (
    <Section
      title="4. Policy"
      expanded={true}
      preview={true}
      areDataValidOnPreview={isValidForLive}
    >
      <Section title="Narrative of Condition Precedent" inside={true}>
        <Typography variant="body1" className={classes.multiline}>
          {scheme?.narrativeOfConditionPrecedent}
        </Typography>
      </Section>

      <Section title="Narrative of Unwind" inside={true}>
        <Typography variant="body1" className={classes.multiline}>
          {scheme?.narrativeOfUnwind}
        </Typography>
      </Section>
    </Section>
  );
}
